module.exports = __webpack_public_path__ + "static/media/BC_Terms.ae7dd8a1.pdf";